import { Integration_Auth_Names_Enum } from '@main/graphql/types.generated';
import z from 'zod/v4';

import * as IntegrationAuth from '../integration-auth';

export type AtlassianAuthSaOauthConfig = (typeof AtlassianAuthSaOauth)['_']['NamedConfig'];

export const AtlassianAuthSaOauth = IntegrationAuth.manual({
  name: Integration_Auth_Names_Enum.ServiceAccountOauth,
  configSchema: z.object({
    cloudId: z.uuid(),
    clientId: z.string().trim().min(1),
  }),
  encryptedConfigSchema: z.object({
    clientSecret: z.string().trim().min(1),
  }),
});
